import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';

import { Box } from '@mui/material';
import styles from './styles';

const Property = ({
  label,
  children,
  classes,
  disableGutters,
  labelVariant,
  valueVariant,
  display,
}) => (
  <Box
    className={
      !disableGutters
        ? classes.container
        : classes.disableGutters
    }
    sx={{ display }}
  >
    <Typography
      variant={labelVariant}
      className={classes.label}
      sx={[display === 'flex'
        ? { lineHeight: '2.5 !important' }
        : { lineHeight: 0 }]}
    >
      {label}
    </Typography>
    <Typography variant={valueVariant} component="div">
      {children || '-'}
    </Typography>
  </Box>
);

Property.propTypes = {
  label: PropTypes.any,
  children: PropTypes.any,
  classes: PropTypes.object,
  disableGutters: PropTypes.bool,
  labelVariant: PropTypes.string,
  valueVariant: PropTypes.string,
  display: PropTypes.string,
};

Property.defaultProps = {
  label: '',
  children: null,
  classes: {},
  disableGutters: false,
  labelVariant: 'overline',
  valueVariant: 'body1',
  display: 'block',
};

export default withStyles(styles)(Property);
